import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import ErrorBoundary from '../../components/ErrorBoundary';
import Content from '../Content';
import newrelic from './newrelic';
import hotjar from './hotjar';
import heap from './heap';

newrelic.init();
hotjar.init();
heap.init();
heap.track('LoadHeatmap');

const Heatmap = () => {
  const { i18n: _i18n } = useTranslation();
  useEffect(() => {
    const siteCoreLang = (window.ttCentre && window.ttCentre.isoCode) || 'en-GB';
    _i18n.changeLanguage(siteCoreLang);
  }, []);
  return (
    <ThemeProvider>

      <ErrorBoundary>
        <Content />
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default Heatmap;
